import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Liked from "./Liked";
import Saved from "./Saved";
import Shortlisted from "./Shortlisted";
import ExpressedInterest from "./ExpressedInterest";
import Favorite from "./Favorite";
import NotFound from "../NotFound";
const ViewProfile = ({ match, updateHeader, updateBreadcrumb }) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/liked`}
        exact
        render={props => (
          <Liked
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/saved`}
        exact
        render={props => (
          <Saved
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/shortlisted`}
        exact
        render={props => (
          <Shortlisted
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/expressed-interest`}
        exact
        render={props => (
          <ExpressedInterest
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/favorite`}
        exact
        render={props => (
          <Favorite
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        render={props => (
          <NotFound
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
    </Switch>
  );
};

export default ViewProfile;



// WEBPACK FOOTER //
// ./src/_components/Matches/index.js